module.exports = __webpack_public_path__ + "static/media/logo.cab945d8.svg";